<template>
  <!-- While the whitelabel theme color is still loading we show a neutral
       skeleton, so the brand color never flashes a wrong (fallback) value. -->
  <div v-if="!colorReady" class="bank-balance bank-balance--skeleton">
    <div class="bank-balance-inner">
      <div class="sk sk-brand"></div>
      <div class="sk sk-label"></div>
      <div class="sk sk-value"></div>
      <div class="bank-balance-actions">
        <div class="sk sk-btn"></div>
        <div class="sk sk-btn"></div>
      </div>
    </div>
  </div>

  <div v-else class="bank-balance" :style="{ background: brandColor }">
    <div class="bank-balance-inner">
      <div class="bank-balance-head">
        <span class="bank-balance-brand">
          <v-icon small color="white" class="mr-1">account_balance_wallet</v-icon>
          Carteira {{ appName }}
        </span>
      </div>

      <div class="bank-balance-label">Saldo disponível</div>
      <div v-if="isLoading" class="bank-balance-skeleton"></div>
      <div v-else class="bank-balance-value">{{ $n(total, "currency") }}</div>

      <div class="bank-balance-actions">
        <v-btn class="bank-action" flat round to="recharge-wallet">
          <v-icon left small>add</v-icon> Recarregar
        </v-btn>
        <v-btn class="bank-action" flat round to="wallet">
          <v-icon left small>receipt_long</v-icon> Extrato
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Wallet",
  created() {
    this.$store.dispatch("dashboard/getWallet");
    this.$store.dispatch("account/getAccount");
    this.$store.dispatch("system/fetchSystemConfiguration");
  },
  computed: {
    ...mapGetters({
      partner: "account/partner",
      wallet: "dashboard/wallet",
      color: "account/color",
      partnerName: "account/partnerName",
      isLoading: "dashboard/isLoading",
      systemAppName: "system/appName",
      accountLoading: "account/loading",
    }),
    appName() {
      return this.systemAppName || process.env.VUE_APP_APP_NAME || "FlowIt";
    },
    // The theme color is only trustworthy once the account finished loading;
    // until then we render the skeleton instead of a guessed color.
    colorReady() {
      return !this.accountLoading;
    },
    brandColor() {
      return this.color && String(this.color).startsWith("#") ? this.color : "#1976D2";
    },
  },
  data() {
    return {
      total: 0,
    };
  },
  watch: {
    wallet(newValues) {
      if (newValues && newValues.balance !== undefined) {
        this.total = newValues.balance;
      }
    },
  },
};
</script>

<style scoped>
.bank-balance {
  border-radius: 20px;
  color: #ffffff;
  box-shadow: 0 14px 36px rgba(20, 30, 60, 0.18);
  position: relative;
  overflow: hidden;
}
.bank-balance::after {
  content: "";
  position: absolute;
  top: -60px;
  right: -40px;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
}
.bank-balance-inner {
  position: relative;
  padding: 24px 26px 22px;
  z-index: 1;
}
.bank-balance-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bank-balance-brand {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  opacity: 0.9;
  display: inline-flex;
  align-items: center;
}
.bank-balance-label {
  margin-top: 18px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  opacity: 0.8;
}
.bank-balance-value {
  font-size: 34px;
  font-weight: 800;
  line-height: 1.1;
  margin-top: 4px;
}
.bank-balance-skeleton {
  height: 38px;
  width: 60%;
  margin-top: 6px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.25);
  animation: pulse 1.4s infinite;
}
.bank-balance-actions {
  display: flex;
  gap: 12px;
  margin-top: 22px;
}
.bank-action {
  flex: 1;
  margin: 0 !important;
  background: rgba(255, 255, 255, 0.18) !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.2px;
}
@keyframes pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 0.9; }
}

/* Skeleton state (before the whitelabel color loads) */
.bank-balance--skeleton {
  background: #e9edf3;
}
.bank-balance--skeleton::after {
  display: none;
}
.sk {
  border-radius: 8px;
  background: linear-gradient(90deg, #dfe4ec 25%, #eef1f6 50%, #dfe4ec 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}
.sk-brand { width: 120px; height: 14px; }
.sk-label { width: 90px; height: 12px; margin-top: 20px; }
.sk-value { width: 55%; height: 34px; margin-top: 8px; }
.sk-btn { flex: 1; height: 40px; border-radius: 22px; }
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
